export default __webpack_public_path__ + "static/media/scopri.7822ec45.png";